export default "__VITE_ASSET__LgxbTab0__"